<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {isManagerSystemRole} from "@/api/Apis";
import store from "@/store";

export default {
  name: 'App',
  created() {
    isManagerSystemRole().then(res=>{
      store.commit("permission/SET_IsSystemManager",res.data.data.isSysManager)
    })
  }
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue